import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=23add0ce&scoped=true"
import script from "./msgDialog.vue?vue&type=script&lang=js"
export * from "./msgDialog.vue?vue&type=script&lang=js"
import style0 from "./msgDialog.vue?vue&type=style&index=0&id=23add0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23add0ce",
  null
  
)

export default component.exports